import type { CanvasSession, PhaseCode, Stage } from "./schema";
import { PHASES } from "./schema";

interface Props {
  session: CanvasSession;
}

function statusOf(session: CanvasSession, code: PhaseCode): "complete" | "current" | "locked" {
  const state = session.phases[code];
  if (state.status === "complete") return "complete";
  if (session.currentStage === code) return "current";
  return "locked";
}

function drStatus(session: CanvasSession): "complete" | "current" | "locked" {
  if (session.currentStage === "COMPLETE") return "complete";
  if (session.deploymentReadiness.status === "complete") return "complete";
  if (session.currentStage === "DR") return "current";
  return "locked";
}

function outputStatus(stage: Stage): "complete" | "current" | "locked" {
  return stage === "COMPLETE" ? "current" : "locked";
}

export function PhaseTracker({ session }: Props) {
  return (
    <ol className="tracker" aria-label="Canvas progress">
      {PHASES.map((p, idx) => {
        const st = statusOf(session, p.code);
        return (
          <li key={p.code} className={`tracker__step tracker__step--${st}`}>
            <span className="tracker__index">{String(idx + 1).padStart(2, "0")}</span>
            <span className="tracker__code">{p.code}</span>
            <span className="tracker__title">{p.title}</span>
            <span className="tracker__rule" aria-hidden />
          </li>
        );
      })}
      <li className={`tracker__step tracker__step--${drStatus(session)}`}>
        <span className="tracker__index">07</span>
        <span className="tracker__code">DR</span>
        <span className="tracker__title">Readiness</span>
        <span className="tracker__rule" aria-hidden />
      </li>
      <li className={`tracker__step tracker__step--${outputStatus(session.currentStage)}`}>
        <span className="tracker__index">08</span>
        <span className="tracker__code">·</span>
        <span className="tracker__title">Output</span>
      </li>
    </ol>
  );
}
